<template>
  <main class="residency-inputs" :style="`grid-template-columns: repeat(${columns}, 1fr);`">
    <ApfBasicInput :name="fields.status"
                   :validator="validator"
                   label="Residency Status when in Singapore">
      <select class="form-control" v-model="form[fields.status]" @change="$emit('onResidencyChange')">
        <template>
          <option v-for="opt of getResidencyOptions()" :value="opt.value" :key="opt.value">{{ opt.label }}</option>
        </template>
      </select>
    </ApfBasicInput>
    <ApfBasicInput
        :name="fields.number" :validator="validator"
        v-if="showNumberInput" :label="`${residencyDoc==='Student Pass'?'FIN':residencyDoc} No.`">
      <input class="form-control" type="text" v-model="form[fields.number]"/>
    </ApfBasicInput>

    <ApfBasicInput
        :name="fields.expiry" :validator="validator"
        v-if="showExpiryDateInput" :label="`${residencyDoc} Expiry Date`">
        <el-date-picker
            type="date" v-model="form[fields.expiry]"
            format="dd/MM/yyyy" value-format="dd/MM/yyyy"
            placeholder="Pick a day" :picker-options="group!=='MIS'&&datePicker"
        />
    </ApfBasicInput>
    <ApfBasicInput
        :name="fields.issueDate" :validator="validator"
        v-if="showIssueDateInput" :label="`${residencyDoc} Issue Date `">
        <el-date-picker
            type="date" v-model="form[fields.issueDate]"
            format="dd/MM/yyyy" value-format="dd/MM/yyyy"
            placeholder="Pick a day" :picker-options="group!=='MIS'&&datePicker"
        />
    </ApfBasicInput>
  </main>
</template>

<script>
import ApfBasicInput from "@/pages/application/components/ApfBasicInput";
import { constApfMISResidency, constApfResidency } from "@/pages/application/const/applicationConst";


export default {
  props: ['columns', 'form', 'fields', 'validator', 'type','group'],
  components: {ApfBasicInput},
  computed: {
    showNumberInput(){
      if(['Immigration Exemption Order'].includes(this.residencyDoc)){
        return null
      }else{
        return this.residencyDoc;
      }
    },
    showExpiryDateInput() {
      return this.residencyDoc && this.residencyDoc !== 'NRIC' && this.residencyDoc !== 'Birth Certificate';
    },
    showIssueDateInput() {
      return this.residencyDoc && this.residencyDoc === 'Student Pass';
    },
    residencyDoc() {
      switch (this.form[this.fields.status]) {
        case 'SC(Citizen)':
          return this.type === 'child' ? 'Birth Certificate' : 'NRIC';
        case 'PR(Permanent Resident)':
          return this.type === 'child' ? 'Re-Entry Permit' : 'NRIC';
        case 'DP(Dependant Pass)':
        case 'EP(Employment Pass)':
        case 'LTVP(Long Term Visit Pass)':
        case 'Diplomatic Pass':
          return 'FIN';
        case 'Foreigner':
          return 'Passport';
        case "STP(Student Pass)":
          return "Student Pass";
        case "Immigration Exemption Order":
          return "Immigration Exemption Order"
        default:
          return null;
      }
    }
  },
    data(){
      return{
          datePicker: {
              disabledDate(date) {
                  return date > new Date().getTime();
              }
          },
      }
    },
  methods:{
    getResidencyOptions(){
      return this.type === "child" ? constApfMISResidency.child : constApfMISResidency.parent;
    },
  }
}
</script>

<style scoped>
.residency-inputs {
  display: grid;
  column-gap: 3rem;
  row-gap: 1.5rem;
}
</style>